import React, { useState } from "react";

const CloseIcon = ({
  color = "#B30838",
  width = "24",
  height = "24",
  className = "",
  hoverColor = "#333",
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <svg
      {...props}
      fill="none"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <g clip-path="url(#clip0_3734_5314)">
        <path
          d="M12 10.3024L8.60586 6.9082L6.90881 8.60525L10.303 11.9994L6.90881 15.3935L8.60586 17.0905L12 13.6964L15.3941 17.0905L17.0911 15.3935L13.697 11.9994L17.0911 8.60525L15.3941 6.9082L12 10.3024Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM8.60588 6.90883L12 10.303L15.3941 6.90883L17.0911 8.60588L13.697 12L17.0911 15.3941L15.3941 17.0911L12 13.697L8.60588 17.0911L6.90883 15.3941L10.303 12L6.90883 8.60588L8.60588 6.90883Z"
          fill={isHovered ? hoverColor : color}
          className="transition-colors duration-200"
        />
      </g>
      <defs>
        <clipPath id="clip0_3734_5314">
          <rect width="24" height="24" fill="transparent" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CloseIcon;
